
<template>
  <div class="d-flex align-center justify-center"> 
    <v-btn
      v-if="!sellNotes"
      icon
      @click="startEditingDialog()"
      @dblclick.stop
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div @click="startEditingDialog()" class="cursor-pointer primary--text text-decoration-underline" v-else>Voir</div>
  </div>
</template>
<script>
const { VUE_APP_GATEWAY_HOST } = process.env;

import { makeFetchRequest } from '../../utils';
import { EventBus } from '../../mixins'

import dayjs from "dayjs";
// import advancedFormat from 'dayjs/plugin/advancedFormat';
// dayjs.extend(advancedFormat);

export default {
  props: {
    sellNotes: {
      type: String,
      default: null
    },
    updatedItem: {
      type: Object,
      default: null
    }
  },
  methods: {  
    async setSellNotes() {
      this.$emit('toggle-loading');

      const dateString = dayjs.utc(this.updatedItem.date).format("DD-MM-YYYY");

      const body = {
        query: `mutation iresaSetSellNotes($packageCode: Int!, $date: String!, $sellNotes: String!, $idPartner: Int!, $marque: Int!) { 
          iresaSetSellNotes(packageCode: $packageCode, date: $date , sellNotes: $sellNotes, idPartner: $idPartner, marque: $marque) { 
            success message data 
          }
        }`,
        variables: {
          packageCode: parseInt(this.updatedItem.packageCode),
          date: dateString,
          sellNotes: this.updatedItem.value,
          idPartner: this.updatedItem.partenaire,
          marque: this.updatedItem.marque
        }
      }

      const notification = {
          type: 'success'
      };

      // Mutation to save min depart guarantee
      await makeFetchRequest(VUE_APP_GATEWAY_HOST, 'POST', body).then(() => {
        notification.message = "Sell Notes enregistrée";
        this.$emit('set-items-new-value');
      }).catch(err => {
        console.log("ERR: ", err)  
        notification.type = "danger";
        notification.message = "Une erreur s'est produite";
      });

      this.$emit('toggle-loading');
      this.$emit('reset-dialog');

      EventBus.$emit('show-notifications', [notification]);
    },
    startEditingDialog() {
      this.$emit('start-editing-dialog', this.setSellNotes);
    }
  }
};
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
